// Explicit, observed Control origins only. A member Core address never creates a new staff-login destination.
const CONTROL_ENTRIES = Object.freeze({
  preview: Object.freeze({ origin: "https://system-master-4.preview.emergentagent.com", label: "Vorschau" }),
  production: Object.freeze({ origin: "https://control.visibilis.life", label: "PROD" }),
});

// Plain navigation after the existing Core/environment check. No session handoff.
export function teamManagementEntry(env, verified) {
  if (verified !== true || !env || !Array.isArray(env.problems) || env.problems.length !== 0) return null;
  const entry = Object.prototype.hasOwnProperty.call(CONTROL_ENTRIES, env.key) ? CONTROL_ENTRIES[env.key] : null;
  if (!entry || env.core !== entry.origin) return null;
  return { href: entry.origin + "/beide-apps", label: entry.label };
}
